export class CustomerItem {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly siteIds?: number[],
  ) {}
}
